import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatTableDataSource, MatDialog, MatSort } from '@angular/material';
import { OrderService } from '../../services/order/order.service';
import { DatePipe } from '@angular/common';
import { NgxDateRangePickerOptions } from '../../../ngx-daterangepicker';
import { Subscription, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AllorderdetailsComponent } from '../order/allorderdetails/allorderdetails.component';
import * as AWS from 'aws-sdk';
import { environment } from '../../../environments/environment';
import { ImagePopup } from '../order/allorderdetails/allorderdetails.component';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { TokenStorage } from 'src/app/auth/token.storage';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MM YYYY',
  },
};

@Component({
  selector: 'app-snreport',
  templateUrl: './snreport.component.html',
  styleUrls: ['./snreport.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'it' }, //you can change useValue
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})
export class SnreportComponent implements OnInit {

  columnsToDisplay = [
    'invoice',
    'productDetails',
    'serialno',
    'snImg'
  ];
  selected = '90';
  options: NgxDateRangePickerOptions;
  orderDataArray = new MatTableDataSource();
  page: number = 0;
  excelRecords = [];
  totalRecords: number = 0;
  range = [1, 2, 3, 4, 5];
  daterRangevalue: any;
  fromDate: any;
  toDate: any;
  isDateFiltered: boolean = false;
  orders = [];
  orderStateArray = ["ORDER_STATE_DELIVERED", "ORDER_STATE_IN_TRANSIT", "ORDER_STATE_FAILED", "ORDER_STATE_UNPLANNED", "ORDER_STATE_SCHEDULED"]
  selectedValue = [];
  isLoading = true;
  prevFromDate: any;
  prevTodate: any;
  bucket: string;
  protected ngUnsubscribe: Subject<void> = new Subject<void>();

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  constructor(public orderService: OrderService,
    public datePipe: DatePipe,
    private token: TokenStorage,
    public dialog: MatDialog) {

  }

  ngOnInit() {
    this.daterRangevalue = new Date();
    this.fromDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.toDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.orderFilter();

  }

  ngAfterViewInit() {
    this.orderDataArray.paginator = this.paginator;
  }


  orderFilter() {
    this.orderDataArray.data = [];
    this.isLoading = true;
    this.getData(this.fromDate, this.toDate).pipe(takeUntil(this.ngUnsubscribe)).subscribe(orders => {
      if (orders) {
        this.orders = orders.filter(function (order) {
          return order.orderstatus == "ORDER_STATE_DELIVERED";
        });
      console.log("orders in report", this.orders);
      if (this.orders.length > 0)
        this.getSNimages(this.orders)
      }
      this.isLoading = false;
    }, Error => {
      this.isLoading = false;
    })
  }

  getSNimages(orders) {
    let s3 = new AWS.S3(environment.S3Key);
    let count = 0;
    let bucket = this.token.getTenant()
    orders.forEach(order => {
      count = count + 1;
      this.orderDataArray.data = [];
      this.isLoading = true;
      s3.listObjectsV2({
        Bucket: bucket,
        Prefix: 'serialnumbers/' + order.invoice_number + '/' + order.orderId + '/' + order.productId,
      }, function (err, serialNumImages) {
        if (err) {
          console.log(err);
        }
        else {
          let url;
          if (serialNumImages && serialNumImages.Contents.length > 0) {
            url = s3.getSignedUrl('getObject', {
              Bucket: bucket,
              Key: serialNumImages.Contents[0].Key
            })
            order.SNurl = url;
          }
        }
      })
      if (count == orders.length) {
        console.log("count", count, orders.length)
        this.orderDataArray.data = orders;
        this.isLoading = false;
      }
    });

  }

  getData(from, to) {
    let orderStates = ['ORDER_STATE_DELIVERED']
    return this.orderService.getOrderReportByStates(from, to, orderStates);
  }

  sortByDate(event) {
    this.ngUnsubscribe.next()
    this.fromDate = this.datePipe.transform(new Date(event.value), 'yyyy-MM-dd');
    this.toDate = this.datePipe.transform(new Date(event.value), 'yyyy-MM-dd');
    if (this.toDate != this.prevTodate || this.fromDate != this.prevFromDate) {
      this.isDateFiltered = true;
      this.orderFilter();
    }
  }
  openImage(event) {
    const dialogR = this.dialog.open(ImagePopup, {
      data: event.srcElement.currentSrc
    });
    dialogR.updatePosition({
      top: '74px'
    });
  }

  orderDetails(orderid) {
    let editDialog = this.dialog.open(AllorderdetailsComponent, {
      width: '800px',
      data: {
        orderId: orderid,
        component: 'orderReport'
      }
    });
    editDialog.updatePosition({
      top: '50px', right: '0px',
    });
  }

  applyFilter(filterValue: string) {
    this.orderDataArray.filter = filterValue.trim().toLowerCase();
  }
}
